import dayjs from "dayjs";

const TOUR_COLORS = [
  "#00b894",
  "#e17055",
  "#0984e3",
  "#6c5ce7",
  "#fd79a8",
  "#fdcb6e",
  "#00cec9",
  "#a29bfe",
];

export const getTourColor = (id) => TOUR_COLORS[id % TOUR_COLORS.length];


const KO_WEEKDAYS = ["일", "월", "화", "수", "목", "금", "토"];


export const fmtDateRangeKo = (start, end) => {
  if (!start) return null;
  const s = dayjs(start);
  const sStr = `${s.format("MM/DD")}(${KO_WEEKDAYS[s.day()]})`;
  if (!end || s.isSame(dayjs(end), "day")) return sStr;
  const e = dayjs(end);
  const eStr = `${e.format("MM/DD")}(${KO_WEEKDAYS[e.day()]})`;
  return `${sStr} ~ ${eStr}`;
};

// 날짜가 투어 기간에 포함되는지, 그리고 시작/중간/종료 구분
export const getBarType = (date, tour) => {
  if (!tour.start_date) return null;
  const d = dayjs(date);
  const start = dayjs(tour.start_date);
  const end = tour.end_date ? dayjs(tour.end_date) : start;

  if (!d.isBetween(start, end, "day", "[]")) return null;

  const isStart = d.isSame(start, "day");
  const isEnd = d.isSame(end, "day");
  const dow = d.day(); // 0=일, 6=토
  const isWeekStart = dow === 0;
  const isWeekEnd = dow === 6;

  if (isStart && isEnd) return "bse";
  if (isStart || isWeekStart) {
      if (isEnd || isWeekEnd) return "bse";
      return "bs";
  }
  if (isEnd || isWeekEnd) return "be";
  return "bm";
};